const openCls = "js-hdr-lang-open";


export function init(element) {
	function cb(e) {
		element.classList.remove(openCls);
		e.stopImmediatePropagation();
		e.currentTarget.removeEventListener("click", cb, true);
	}

	element.addEventListener("click", () => {
		if(element.classList.toggle(openCls)) {
			document.body.addEventListener("click", cb, true);
		}
	})

	window.addEventListener("scroll", _ => {
		element.classList.remove(openCls)
		document.body.removeEventListener("click", cb, true);
	});
}
